export interface IIngameItem {
    type: eIngameItems
    label: string
    id: string //id on blockchain 
    image: string
    balance: number
}

export interface ICurrencyItem {
    currency: string
    image: string
    balance: number
}

export interface IBalanceItem extends IIngameItem, ICurrencyItem {
    key: | eIngameItems | eCurrencyItems //name of item for emit
}


export enum eIngameItems {
    LOOTBOX_BASIC = 'LOOTBOX_BASIC',
    LOOTBOX_MEDIUM = 'LOOTBOX_MEDIUM',
    LOOTBOX_PREMIUM = 'LOOTBOX_PREMIUM',
    UNFREEZE_POTION = 'UNFREEZE_POTION',
    DIAMOND_STORY_CHEST = 'DIAMOND_STORY_CHEST',
    BATTLE_STAMINA_POTION = 'BATTLE_STAMINA_POTION',
}


export enum eCurrencyItems {
    KMON = 'KMON',
    BNB = 'BNB',
    POINTS = 'POINTS',
    CANDIES = 'CANDIES'
}
